import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../Common/styles/LoginModal.module.scss';

import Button from '../Common/Button';
import Dialog from '../Common/Dialog';
// Images.
import playBadge from '../../images/google-play-badge.svg';
import appleBadge from '../../images/app-store-badge.svg';

type Props = {
  showModal: boolean;
  setShowModal: (value: React.SetStateAction<boolean>) => void;
};
/**
 * An overlay modal for mobile app
 *
 * @returns React.JSX.Element
 */
const AppCtaModal: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog openModal={props.showModal} closeModal={() => props.setShowModal(false)}>
      <div className={`${styles.modal} ${styles.appModal}`}>
        <Button className="alertBannerCloseBlack" onClick={(): void => props.setShowModal(false)}>
          {t('common:general.close')}
        </Button>
        <h2>{t('landingPage:appCta.title')}</h2>
        <p>{t('landingPage:appCta.description')}</p>
        <div className={styles.storeLinks}>
          <a href={import.meta.env.VITE_GOOGLE_LINK}>
            <img src={playBadge} alt={`${t('landingPage:appCta.downLoadApp')} ${t('landingPage:appCta.googlePlay')}`}></img>
          </a>
          <a href={import.meta.env.VITE_APPLE_LINK}>
            <img src={appleBadge} alt={`${t('landingPage:appCta.downLoadApp')} ${t('landingPage:appCta.appleApp')}`}></img>
          </a>
        </div>
      </div>
    </Dialog>
  );
};

export default AppCtaModal;
